require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./javascript-algorithms-and-data-structures-es-6-use-class-syntax-to-define-a-constructor-function.json") })
        }
      }, "path---javascript-algorithms-and-data-structures-es-6-use-class-syntax-to-define-a-constructor-function");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---javascript-algorithms-and-data-structures-es-6-use-class-syntax-to-define-a-constructor-function!./.cache/json/javascript-algorithms-and-data-structures-es-6-use-class-syntax-to-define-a-constructor-function.json
// module id = 2382
// module chunks = 231608221292675